import { useState, type FormEvent } from "react";
import { siteConfig } from "@/mocks/chiGuaData";

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const [toast, setToast] = useState("");

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (!kw) {
      setToast("先输入你感兴趣的话题吧～");
      return;
    }
    setToast(`正在为你寻找「${kw}」相关的新鲜话题…`);
    setTimeout(() => setToast(""), 3600);
  };

  return (
    <section
      id="top"
      className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20playful%20abstract%20background%20with%20soft%20melons%2C%20watermelon%20slices%20and%20floating%20speech%20bubbles%2C%20warm%20coral%2C%20amber%20and%20cream%20gradient%2C%20smooth%20artistic%20shapes%2C%20no%20text%2C%20modern%20editorial%20illustration&width=1800&height=1200&seq=hero-gossip-x1&orientation=landscape"
        alt="吃瓜网上在线看精选内容与热门话题"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-900/55 to-primary-950/80"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-4 py-24 text-center">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
          <i className="ri-fire-fill text-accent-400" aria-hidden="true"></i>
          每日新鲜事 · 实时更新
        </span>
        <h1 className="font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          {siteConfig.slogan}
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-50/85 md:text-lg">
          吃瓜网上在线看精选内容，冲浪指南帮你快速找到感兴趣的话题，浏览推荐不错过任何精彩。随时随地在线刷瓜，热门事件、新鲜事持续更新。
        </p>

        <form
          onSubmit={onSubmit}
          className="mt-9 flex w-full max-w-xl flex-col gap-3 sm:flex-row sm:items-center sm:rounded-full sm:border sm:border-background-50/30 sm:bg-background-50/15 sm:p-1.5 sm:backdrop-blur"
        >
          <div className="relative flex items-center">
            <i className="ri-search-line pointer-events-none absolute left-4 text-lg text-background-50/70" aria-hidden="true"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜你想吃的话题，比如：综艺、科技、体坛…"
              className="w-full rounded-full bg-background-50/15 py-3 pl-12 pr-4 text-sm text-background-50 placeholder:text-background-50/60 outline-none backdrop-blur sm:rounded-full sm:bg-transparent"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400 sm:rounded-full"
          >
            搜索话题
          </button>
        </form>
        {toast && (
          <p className="mt-4 animate-fade-up rounded-full bg-background-50/20 px-4 py-2 text-sm text-background-50">
            {toast}
          </p>
        )}

        <div className="mt-9 flex flex-wrap items-center justify-center gap-2">
          <span className="text-sm text-background-50/70">热门推荐：</span>
          {["影视综艺", "AI 前沿", "体坛风云", "生活趣闻"].map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setKeyword(t)}
              className="whitespace-nowrap rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 text-xs text-background-50 transition-colors hover:bg-accent-500 hover:border-accent-500"
            >
              #{t}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}